<template>
  <div id="app">
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <LayoutWeb />
  </div>
</template>

<script>
import LayoutWeb from '../components/LayoutWeb.vue'

export default {
  name: 'app',
  components: {
    LayoutWeb
  }
}
</script>

<style lang="scss">
* {
    margin: 0;
    padding: 0;
}
body {
  background: #fffaf6;
}
a{
  text-decoration: none;   
}
ul,ol,li{
    list-style: none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
